import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { GlobalPopupModule } from '../global-popup';
import { UserEmulationComponent } from './user-emulation.component';
import { CovanceAgGridModule } from '../covance-ag-grid/covance-ag-grid.module';
import { ReactiveFormsModule } from '@angular/forms';
import { UserEmulationStorage } from './user-emulation-storage';
import { UserEmulationGroupRenderer } from './user-emulation-group-renderer.component';

@NgModule({
    declarations: [
        UserEmulationComponent,
        UserEmulationGroupRenderer
    ],
    imports: [
        SharedModule,
        GlobalPopupModule,
        CovanceAgGridModule,
        ReactiveFormsModule
    ],
    providers: [
        UserEmulationStorage
    ],
    entryComponents: [
        UserEmulationGroupRenderer
    ]
})
export class UserEmulationModule { }